export { IndexMapper } from "./indexMapper.mjs";
export { getRegisteredMapsCounter } from "./mapCollections/mapCollection.mjs";
export { getIncreasedIndexes, getDecreasedIndexes, alterUtilsFactory } from "./maps/utils/index.mjs";
export * from "./maps/index.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/translations/index.mjs
// module id = 85
// module chunks = 1